// extracted by mini-css-extract-plugin
export var box = "_1l-1";
export var checked = "_1l-2";
export var descriptionSpacer = "_1l-9";
export var disabled = "_1l-3";
export var icon = "_1l-6";
export var input = "_1l-0";
export var labelSpacer = "_1l-8";
export var medium = "_1l-5";
export var small = "_1l-4";
export var text = "_1l-7";